import React, { useMemo, useRef } from 'react';
import './index.scss';
import { Bubble } from 'tea-component';

import noChart from '@/pages/datalab/assets/img/noChart.png';
import { useIntl } from 'umi';

const ItemCard = (porps: any) => {
  const { data = {}, handleDragStart } = porps;
  const TextDom = useRef(null);
  const { formatMessage } = useIntl();
  const showBubble =
    TextDom?.current?.scrollHeight > TextDom?.current?.offsetHeight;

  const getDragStart = (e: any) => {
    const cloneNode = e.target.cloneNode(true);
    cloneNode.id = 'dbl-cloneDom';
    document.body.appendChild(cloneNode);
    e.dataTransfer.setDragImage(cloneNode, e.clientX, e.clientY);
    cloneNode.style =
      `position:fixed;left:-50px;top:-50px;z-index:999;cursor: grabbing;pointer-events:none;transform:translate3d( ${ 
        e.clientX 
      }px ,${ 
        e.clientY 
      }px,0);`;
  };
  const GetDarg = (e: any) => {
    const cloneNode = document.getElementById('dbl-cloneDom');
    if (cloneNode) {
      // @ts-ignore
      cloneNode.style =
        `position:fixed;left:-50px;top:-50px;z-index:999;pointer-events:none;cursor: grabbing;transform:translate3d( ${ 
          e.clientX 
        }px ,${ 
          e.clientY 
        }px,0);`;
    }
  };

  // 提示文案（图表被使用>名称过长）
  const content = useMemo(() => {
    const { name, disable } = data || {};
    const disableContent = disable ? formatMessage({ id: 'dbl_common_dashboard_disabled' }) : null;
    const nameContent = showBubble ? name : null;
    return disableContent || nameContent;
  }, [data, formatMessage, showBubble]);

  return (
    <>
      <Bubble placement="left" dark content={content}>
        <div
          className={`dbl-item-card ${data?.disable ? 'disable' : ''}`}
          draggable={!data?.disable}
          // unselectable="on"
          onDragStart={(e) => {
            // console.log('onDragStart data', data);
            // if (!data.disable) {
            //   handleDragStart(e, data.type);
            // }
            handleDragStart?.(data);
            getDragStart(e);
          }}
          onDrag={(e) => {
            GetDarg(e);
          }}
          onDragOver={(e) => {
            GetDarg(e);
          }}
          onDragEnd={() => {
            const cloneNode = document.getElementById('dbl-cloneDom');
            if (cloneNode) {
              document.body.removeChild(cloneNode);
              handleDragStart?.(null);
            }
          }}
        >
          <div className="dbl-item-card-context">
            <div className="dbl-item-card-img">
              <img src={data?.img ? data?.img : noChart} draggable="false" />
            </div>
            <div className="dbl-item-card-box">
              <div className="dbl-item-card-title" ref={TextDom}>
                {data?.title}
              </div>
              <div>
                <div className="dbl-item-card-text">{data?.owner}</div>
                <div className="dbl-item-card-date">{data?.create_time}</div>
              </div>
            </div>
          </div>
        </div>
      </Bubble>
    </>
  );
};

export default ItemCard;
